import React from 'react';
import logo from './logo.svg';
import { Route } from "react-router";
import { BrowserRouter as Router,   Link, Routes } from 'react-router-dom';
import './App.css';
import Home from './pages/Home/Home';
import Login from './pages/Home/Login/Login';
import Dashboard from './components/Dashboard/Dashboard';
import TrendingStock from './components/TrendingStock/Trendingstock';
import WatchlistStock from './components/WatchlistStocks/Watchliststock';
import Bullish from './components/Bullish/Bullish';
import Bearish from './components/Bearish/Bearish';
import Catalyst from './components/Catalyst/Catalyst';
import Volatile from './components/Volatile/Volatile';
import Mostactive from './components/Mostactive/Mostactive';
import Insider from './components/Insider/Insider';
import Wicktok from './components/Wicktok/Wicktock';
import Ticker from './components/Ticker/Ticker';
import Search from './components/Search/Search';




function App() {
  return (
    <div className="App">
      <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/login" element={<Login />} />
        <Route path="/trending-stocks" element={<TrendingStock />} />
        <Route path="/watchlist-stocks" element={<WatchlistStock />} />
        {/* Dashboard Components starts here */}
        <Route path="/bullish" element={<Bullish />} />
        <Route path="/bearish" element={<Bearish />} />
        <Route path="/catalyst" element={<Catalyst />} />
        <Route path="/volatile" element={<Volatile />} />
        <Route path="/most-active" element={<Mostactive />} />
        <Route path="/insider" element={<Insider />} />
        <Route path="/wicktock" element={<Wicktok />} />
        <Route path="/ticker-details" element={<Ticker />} />
        <Route path="/search" element={<Search />} />
        {/* Other routes */}
      </Routes>
      </Router>
    </div>
  );
}

export default App;
